'use strict'

// import { IeModal } from './lib/IeModal'
// import { CookiePolicy } from './lib/CookiePolicy'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { KvSlider } from './lib/KvSlider'
import { ProgramSlider } from './lib/ProgramSlider'
import { Opening } from './lib/Opening'
import { articleSlider } from './lib/articleSlider'
import { Tab } from './lib/Tab'
import { SessionCheck } from './lib/SessionCheck'
import { OtherSessionSlider } from './lib/OtherSessionSlider'
import { Accordion } from './lib/Accordion'
import { Modal } from './lib/Modal'
import { CopyClipboard } from './lib/CopyClipboard'
import { LoopSlider } from './lib/LoopSlider'
import { MiramachiKv } from './lib/MiramachiKv'
import { MegaMenu } from './lib/MegaMenu'
import { RegistrationAccordion } from './lib/RegistrationAccordion'

// new IeModal('サイト名', 'http://hoge.com')
// new CookiePolicy('optout')
new Svg()
new TelGrant()
new Smooth()
new Drawer()
new ScrollStatus()
new ScrollAnimation()
new KvSlider()
new ProgramSlider()
new Opening()
new articleSlider()
new Tab()
new SessionCheck()
new OtherSessionSlider()
new Accordion()
new Modal()
new CopyClipboard()
new LoopSlider()
new MiramachiKv()
new MegaMenu()
new RegistrationAccordion()
